"use client";

import { useTranslations } from "next-intl";

import { ButtonLink } from "@/components/ButtonLink";
import { primaryNav } from "@/content/nav";
import { Link } from "@/i18n/navigation";
import { getFrontendLoginUrl, getFrontendSignupUrl } from "@/lib/urls";

import { mobileNavLinkClass } from "./Nav.constants";

type MobileNavFallbackProps = {
  /** Closes the menu after a link is chosen. */
  onNavigate: () => void;
};

/**
 * Plain links under the bar, shown when the menu sheet's code cannot load
 * (for example offline). No dialog code, so it always renders. The next tap
 * on the menu button tries the full menu again.
 */
export const MobileNavFallback = ({ onNavigate }: MobileNavFallbackProps) => {
  const t = useTranslations();

  return (
    <nav
      aria-label={t("nav.a11y.mobileMenuLinks")}
      className="flex flex-col gap-1 rounded-b-2xl border-t border-zinc-200/45 bg-background px-3 pb-3 pt-2 dark:border-white/[0.05] dark:bg-[#0e1018]/95 lg:hidden"
    >
      <Link
        href="/features"
        className={mobileNavLinkClass}
        onClick={onNavigate}
      >
        {t("nav.whatItDoes")}
      </Link>
      {primaryNav.map((item) => (
        <Link
          key={item.href}
          href={item.href}
          className={mobileNavLinkClass}
          onClick={onNavigate}
        >
          {t(item.labelKey)}
        </Link>
      ))}
      <a href={getFrontendLoginUrl()} className={mobileNavLinkClass}>
        {t("nav.login")}
      </a>
      <ButtonLink
        variant="brand"
        className="mt-2 h-10 w-full justify-center"
        href={getFrontendSignupUrl()}
        trackingLocation="nav_mobile_fallback_signup"
      >
        {t("nav.breakDownScript")}
      </ButtonLink>
    </nav>
  );
};
